import { Link } from "react-router-dom";
import { Gavel, Truck, Timer, CheckCircle2 } from "lucide-react";
import { SectionHead } from "@/components/home/CategoriesGrid";

const MODELS = [
  {
    id: "subasta", icon: Gavel, title: "Subastas Rápidas", tag: "Libera tu bodega en 48 hrs", dark: true,
    steps: ["Publicas el lote con precio base", "Transformadores verificados ofertan en vivo", "Cierre automático a las 48 h y retiro coordinado"],
  },
  {
    id: "venta", icon: Truck, title: "Venta Directa / Recolección", tag: "Precio fijo o donación", dark: false,
    steps: ["Defines precio fijo o retiro sin costo", "El comprador agenda el retiro en tu horario", "Trazabilidad y certificado al cerrar"],
  },
];

export const OperationModels = () => (
  <section className="max-w-[1400px] mx-auto px-5 lg:px-8 py-24" data-testid="operation-models-section">
    <SectionHead eyebrow="Modelos de operación" title="Dos formas de mover tu material" />
    <div className="grid lg:grid-cols-2 gap-6">
      {MODELS.map((m) => (
        <div key={m.id} data-testid={`model-card-${m.id}`}
          className={`rounded-3xl p-8 lg:p-10 border hover:-translate-y-1 transition-transform duration-300 ${m.dark ? "bg-[#0a1f18] border-[#1b3d30] text-white" : "bg-white border-slate-200 text-[#05130e]"}`}>
          <div className="flex items-center justify-between mb-8">
            <m.icon className={`w-10 h-10 ${m.dark ? "text-[#00f2a1]" : "text-[#00b37a]"}`} />
            <span className={`flex items-center gap-1.5 text-xs font-mono px-3 py-1 rounded-full ${m.dark ? "bg-[#00f2a1] text-[#05130e]" : "bg-[#f4f7f6] text-slate-600"}`}>
              <Timer className="w-3.5 h-3.5" />{m.tag}
            </span>
          </div>
          <h3 className="text-2xl font-bold mb-6">{m.title}</h3>
          <ol className="space-y-4">
            {m.steps.map((s, i) => (
              <li key={s} className="flex gap-3 items-start">
                <span className={`font-mono text-xs mt-0.5 ${m.dark ? "text-[#00f2a1]" : "text-[#00b37a]"}`}>0{i + 1}</span>
                <span className={m.dark ? "text-slate-300" : "text-slate-600"}>{s}</span>
              </li>
            ))}
          </ol>
          <Link to={`/marketplace?mode=${m.id === "venta" ? "venta,donacion" : "subasta"}`} data-testid={`model-link-${m.id}`}
            className={`mt-8 inline-flex items-center gap-2 text-sm font-semibold ${m.dark ? "text-[#00f2a1]" : "text-[#00915f]"} hover:gap-3 transition-[gap]`}>
            <CheckCircle2 className="w-4 h-4" /> Ver lotes disponibles
          </Link>
        </div>
      ))}
    </div>
  </section>
);
